<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="editFields"></ng-container>
            <ng-container *ngTemplateOutlet="directionButtons"></ng-container>
        </tt-card>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="editFields"></ng-container>
            </tt-card>

            <tt-card class="col-xs-12 col-md-4 p-5">
                <ng-container *ngTemplateOutlet="directionButtons"></ng-container>
            </tt-card>
        </div>
    </div>
</tt-page>

<ng-template #editFields>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="skillscertificate_keyno" [ttModel]="edit.skillscertificate_keyno" ttReadonly></tt-input>
        <tt-select ttLabel="skillscertificatetype" [(ttModel)]="edit.skillscertificatetype_keyno" [ttData]="selectListSkillsCertificateTypes" ttDataId="item_id" ttDataName="item_name"></tt-select>
        <tt-input ttLabel="labour_no" [ttModel]="edit.labour_no" ttReadonly></tt-input>
        <tt-input ttLabel="labour_name" [ttModel]="edit.labour_name" ttReadonly></tt-input>
        <tt-date ttLabel="valid_from_date" [(ttModel)]="edit.valid_from_date"></tt-date>
        <tt-date ttLabel="valid_until_date" [(ttModel)]="edit.valid_until_date"></tt-date>
        <tt-input ttLabel="certificate_id" [(ttModel)]="edit.certificate_id"></tt-input>
        <tt-input ttLabel="issuer_cust_no" [ttModel]="edit.issuer_cust_no" ttReadonly></tt-input>
        <tt-search ttLabel="issuer_cust_name" [(ttModel)]="edit.issuer_cust_name" [ttSearch]="searchIssuerCustomerNames" (ttOnSelected)="onIssuerCustomerNameSelected($event)" (ttOnClear)="onIssuerCustomerNameSelected()"></tt-search>
        <tt-textarea ttLabel="note" [(ttModel)]="edit.note"></tt-textarea>
        <tt-date ttLabel="course_start_date" [(ttModel)]="edit.course_start_date"></tt-date>
        <tt-date ttLabel="course_end_date" [(ttModel)]="edit.course_end_date"></tt-date>
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="edit.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-date ttLabel="reg_datetime" [ttModel]="edit.reg_datetime" ttReadonly></tt-date>
        <tt-input ttLabel="mod_by_portal_user_name" [ttModel]="edit.mod_by_portal_user_name" ttReadonly></tt-input>
        <tt-date ttLabel="mod_datetime" [ttModel]="edit.mod_datetime" ttReadonly></tt-date>
        <tt-button-save ttText="skillcertificate_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </ng-container>
</ng-template>

<ng-template #directionButtons>
    <ng-container *ngIf="!!edit">
        <tt-button-goto [ttText]="'skillscertificate_documents'" [ttBadge]="edit.nbr_of_documents" [ttBeforeGoto]="saveBeforeGoTo" [ttGoto]="'documents'" [ttGotoParms]="{ argtype: 'skillscertificate_keyno', argvalue: edit.skillscertificate_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'skillscertificate_pictures'" [ttBadge]="edit.nbr_of_pictures" [ttBeforeGoto]="saveBeforeGoTo" [ttGoto]="'pictures'" [ttGotoParms]="{ argtype: 'skillscertificate_keyno', argvalue: edit.skillscertificate_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'skillscertificate_checklistdatas'" [ttBadge]="edit.nbr_of_checklistdatas" [ttBeforeGoto]="saveBeforeGoTo" [ttGoto]="'checklistdatas'" [ttGotoParms]="{ argtype: 'skillscertificate_keyno', argvalue: edit.skillscertificate_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>
